var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandsVerification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verification",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48373",
    "data-name": "Path 48373",
    d: "M99.606,93.921a5.685,5.685,0,1,0,5.685,5.685A5.692,5.692,0,0,0,99.606,93.921Zm-1,8.258-2.2-2.2.749-.749,1.465,1.465,3.441-3.3.733.764Z",
    transform: "translate(-90.606 -90.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48374",
    "data-name": "Path 48374",
    d: "M18,9c0-.775-.768-1.44-.959-2.155-.2-.74.13-1.7-.245-2.346s-1.377-.85-1.911-1.384S14.158,1.585,13.5,1.2s-1.606-.047-2.346-.245C10.44.768,9.775,0,9,0S7.56.768,6.845.959c-.74.2-1.7-.13-2.346.245s-.85,1.377-1.384,1.911S1.585,3.842,1.2,4.5,1.157,6.105.959,6.845C.768,7.56,0,8.225,0,9s.768,1.44.959,2.155c.2.74-.13,1.7.245,2.346s1.377.85,1.911,1.384S3.842,16.415,4.5,16.8s1.606.047,2.346.245C7.56,17.232,8.225,18,9,18s1.44-.768,2.155-.959c.74-.2,1.7.13,2.346-.245s.85-1.377,1.384-1.911,1.53-.727,1.911-1.384.047-1.606.245-2.346C17.232,10.44,18,9.775,18,9ZM9,15.744A6.744,6.744,0,1,1,15.744,9,6.752,6.752,0,0,1,9,15.744Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandsVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brands_verification.0b97e78886a20d0d2a051ca80633bf03.svg";